export default __webpack_public_path__ + "static/media/dummy-video.37cd1f6a.webp";